// 全局导入组件
const componentPath = [];
const requireComponent = require.context(
    // 其组件目录的相对路径
    '@/extendModules/',
    // 是否查询其子目录
    true,
    // 匹配基础组件文件名的正则表达式, 这里可以匹配的文件名为TdXxxx.vue格式
    /.(vue)$/
);
requireComponent.keys().forEach(fileName => {
    // 获取组件的路径
    // 剥去文件名开头的 `'./` 和结尾的扩展名
    componentPath.push(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'));
});
export default {
    /**
     * @func  mergeRoutes
     * @desc  拼接路由信息
     * @param {arrey} menus 菜单数组
     * @return {arrey} 路由数组
     */
    mergeRoutes(menus, routes) {
        for (let i = 0; i < menus.length; i++) {
            if (menus[i].children.length > 0) {
                this.mergeRoutes(menus[i].children, routes);
            } else {
                let index = componentPath.indexOf(menus[i].menuUrl);
                if (index > -1) {
                    routes.push({
                        path: '/' + menus[i].menuId,
                        name: menus[i].menuId,
                        component: resolve => require([`@/extendModules/${menus[i].menuUrl}.vue`], resolve),
                        meta: {
                            currentMenu: menus[i]
                        }
                    });
                }
            }
        }
        return routes;
    }
};
